import { Dropdown, Select } from "antd";
import { useState } from "react";
import svg62 from "../../assets/svg/svg62.svg";
import svg36 from "../../assets/svg/svg36.svg";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { numberWithCommas } from "../../utils";

const Yields = () => {
  const url = "api/v2/dashboard/getAllDashboardData";
  const data = useSelector((state) => state.fetch.data[url] || []);

  const maxSize = 100;
  const minSize = 30;
  const [year, setYear] = useState(null);
  const settingItems = [
    {
      key: "1",
      label: (
        <div
        //  onClick={handleEdit}
        >
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            1
          </Link>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div
        // onClick={handleView}
        >
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            2
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white    w-full h-full  ">
      <div className="flex items-center justify-between">
        <span className="font-interSans text-[.75rem] font-[500] text-[#424242]">
          Top Crops Production (Tonnes)
        </span>
      </div>

      {/* <div className="flex  items-start space-y-5 mt-[3.72rem]">
        <div className="relative w-[120px] h-[120px]">
          {data?.majorCrops?.map((bubble, index) => {
            const size = (bubble?.value / 100) * maxSize + minSize;
            const positions = [
              { top: "0px", left: "0px" },
              { top: "5px", left: "70px" },
              { top: "55px", left: "70px" },
            ];
            return (
              <div
                key={index}
                className="absolute group flex items-center justify-center text-white rounded-full"
                style={{
                  width: `${size}px`,
                  height: `${size}px`,
                  top: positions[index].top,
                  left: positions[index].left,
                  backgroundColor: bubble?.color,
                }}
              >
                <span className="text-xs font-bold">{bubble?.value}%</span>

                <div className="absolute bottom-full mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-10 text-left">
                  <div>Title: {bubble?.name}</div>
                  <div>Total: {numberWithCommas(bubble?.total)}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div> */}

      <div className="flex items-start mt-[3.72rem]">
        <div className="relative w-[300px] h-[200px]">
          {data?.majorCrops?.slice(0, 3)?.map((bubble, index) => {
            const size = (bubble?.value / 100) * maxSize + minSize;

            const sizes = data?.majorCrops
              ?.slice(0, 3)
              ?.map((c) => (c?.value / 100) * maxSize + minSize);

            let top = 0;
            let left = 0;

            if (index === 0) {
              top = 40;
              left = 0;
            } else if (index === 1) {
              top = 40 - sizes[1] / 2;
              left = sizes[0] - 10;
            } else if (index === 2) {
              top = 40 + sizes[0] - sizes[2] / 2;
              left = sizes[0] - 10;
            }

            return (
              <div
                key={index}
                className="absolute group flex items-center justify-center text-white rounded-full"
                style={{
                  width: `${size}px`,
                  height: `${size}px`,
                  top: `${top}px`,
                  left: `${left}px`,
                  backgroundColor: bubble?.color,
                }}
              >
                <span className="text-xs font-bold">{bubble?.value}%</span>

                <div className="absolute bottom-full mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-10 text-left">
                  <div>Title: {bubble?.name}</div>
                  <div>Total: {numberWithCommas(bubble?.total)}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex flex-shrink flex-wrap gap-[.94rem] mt-5">
        {data?.majorCrops?.map((bubble, index) => (
          <div key={index} className="flex items-center space-x-2">
            <span
              style={{ backgroundColor: bubble?.color }}
              className={`w-4 h-4  rounded-full`}
            ></span>
            <span className="text-[#615E83] text-[.75rem] font-[400] font-interSans ">
              {bubble?.name}
            </span>
            <span className="text-[#615E83] text-[.75rem] font-[400] font-interSans ">
              {numberWithCommas(bubble?.total)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Yields;
